/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	// rerun lazyload on screen size updates
	jQuery( window ).on( 'resize', function() { dbs.lazyload(); } );

	// Load event function ... most custom stuff goes here. Safer for async.
	jQuery( window ).on( 'load', function() {

		// Resize to parent
		jQuery('img.resize-to-parent, .resize-to-parent img').resizeToParent();

		// Search Form functionality
		jQuery('.search-form__button--open').on('click',function(){ // The click functionality involves three different actions, depending on conditions the various clicks provide.

		// Clicking the search form button checks two classes to see if they are currently active
		var searchCloseLength = jQuery('.search_close').length;
		var openSearchField = jQuery('.search-form--active').length;

		// if .search-form--active is not present, the search field is opened, and the .search-form--active class is applied.
			// Note, this statement also prevents the .search_close span from triggering the search, unless the field is open
		function closeSearch() {
			jQuery('.search-form').removeClass( 'search-form--active' );
			// JS solution
			setTimeout(function() {
				jQuery('.search-form__button--open').attr('aria-expanded', false);
				jQuery('body').removeClass( 'contains-open-search-field' );
				jQuery('.search-form').css('visibility', 'hidden');
			}, 350);
		}

		if (openSearchField <= 0) {
			jQuery('.search-form').addClass( 'search-form--active' );
			jQuery('body').addClass( 'contains-open-search-field' );
			jQuery('.search-form__button--open').attr('aria-expanded', true);
			jQuery('.search-form').css('visibility', 'visible');

			// This function removes the classes related to an open search field, thus closing the search.
			jQuery('.search_close').on('click',function(e){
				jQuery('.search-form__button--open').focus();
				e.stopPropagation();
				e.preventDefault();
				closeSearch();
			});

			jQuery('.search_close').on('keydown',function(e){
				if ( e.keyCode == 9 != e.shiftKey ) { // tab key maps to keycode `9`
					e.preventDefault();
					jQuery('.search-input').focus();
				}
			});

			jQuery('.search-input').on('keydown',function(e){
				if ( e.keyCode == 9 && e.shiftKey ) { // tab key maps to keycode `9`
					e.preventDefault();
					jQuery('.search_close').focus();
				}
			});


			var windowSize = jQuery(window).width();
			if ( windowSize >= 992) {
				event.preventDefault();
				jQuery('.search-form__field').addClass('search-form__focus');
				jQuery('.search-input').focus();
			}
		}

		//Hide the search bar after click out of it
		jQuery('#content').on('click',function(e){
			closeSearch();
		});

		jQuery(window).on( 'keyup', function(e){
			if ( e.keyCode == 27 && (jQuery('.search-form').hasClass('search-form--active'))) { // escape key maps to keycode `27`
				jQuery('.search-form__button--open').focus();
				closeSearch();
			}
		});
		});
		
		/**
		 * Offsets page when scrolling to anchor link to account for sticky header height
		 */

		var adjustAnchor = function() {
			var $anchor = $(':target'),
				fixedElementHeight = 200;
			if ($anchor.length > 0) {
				window.scrollTo(0, $anchor.offset().top - fixedElementHeight);
			}
		};
		$(window).on('hashchange load', function() {
			adjustAnchor();
		});

		// search child dom elements for a[href], and follow the fist one on click events 2015-11-03
		jQuery( ".linkclicker" ).click( function(e) {
			var _this = jQuery( this );
			if ( _this.find( "a" ) ) {
				e.preventDefault();
				if ( _this.find( "a:first" ).attr( "target" ) ) {
					// new tab
					window.open( _this.find( "a:first" ).attr( "href" ) );
				} else {
					// same tab
					window.location = _this.find( "a:first" ).attr( "href" );
				}
			}
		});


	/**
	* Force external links to open in a new tab.
	* 2019-07-11 - TA
	*/
	// From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
	function link_is_external(link_element) {
		return (link_element.host !== window.location.host);
	}

    var anchorElements = document.getElementsByTagName('a');
		for (let anchorElement of anchorElements) {

			if (link_is_external(anchorElement)) {
				anchorElement.classList.add('external-link');
				anchorElement.setAttribute('target','_blank');
				anchorElement.setAttribute('rel','noopener');

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement('span');
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild(assistiveTextContainer.firstChild);
			}
		}

		// 2016-05-15, special declaration for pdf files
		if ( ! jQuery( 'a' ).attr( 'target' ) ) {
			jQuery( 'a[href$=".pdf"]' ).attr( 'target', '_blank' );
		}
		// END FORCE EXTERNAL LINKS

		/**
		 * 	The following removes gratuitous p tags inserted by the editor around img tags. 2018-03-28
	 	 */
		jQuery( ".layout p" ).each( function() { 	         		// For each paragraph of .layout class
			if ( (jQuery(this).find( "img" ).length ) &&     		// If there's an image
					( !jQuery.trim(jQuery(this).text()).length ) ) {// and there's no text, then ... get mean.
				jQuery(this).closest( "p" ).find( "*" ).first().addClass( "unwrapped" ).unwrap();  // if the ancestor is a p tag, do what you have to do
			}
		}); // End p tag removal functionality


	}); // End of jQuery .load function

	// Include ready events here
	jQuery( function() {

		// ========================
		// Arrow-down button scroll
		// ========================
		jQuery('#down-button').click(function() {
			$('html, body').animate({
				scrollTop: ($('main > div:nth-of-type(2)').offset().top - $('.site-header').height())
			},500);
		});

	});

	/**
	 * Load CSS Files Dynamically
	 *
	 * Helpful for on demand loading of files not integral to the immediate
	 * function of the site, saving initial load time.
	 * For the inspiration of this function:
	 * 	https://stackoverflow.com/questions/5680657/adding-css-file-with-jquery
	*/

	jQuery.loadCSS = function(url) {
		// https://stackoverflow.com/questions/5680657/adding-css-file-with-jquery
		if (!$('link[href="' + url + '"]').length)

		if (document.createStyleSheet) { // ie fix
			document.createStyleSheet(url);
		} else {
			$('head').append('<link rel="stylesheet" type="text/css" href="' + url + '">');
		}
	}

})();
